import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';

const CsvPreview = ({ preview }) => (
  <ReactTable
    columns={preview.meta.fields.map(field => ({
      Header: field,
      accessor: field,
    }))}
    data={preview.data}
    showPagination={false}
    minRows={0}
    defaultPageSize={100}
    className="c-table c-reports c-csv-preview-table u-mt+"
  />
);

CsvPreview.propTypes = {
  preview: PropTypes.array.isRequired,
};

export default CsvPreview;
